// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkBox_container {
  display: flex;
  justify-content: center;
}
.SocialMediaCard_container {
  padding: 3.125rem;
  background-color: #f1f1f1;
  border-radius: 1.25rem;
  height: 100%;
  align-items: center;
}
.SocialMediaCard_container div {
  display: flex;
  justify-content: center;
  width: 100%;
}
.SocialMediaCard_container div button {
  border-radius: 0.625rem;
  display: flex;
  gap: 0.625rem;
  align-items: center;
  width: 13.125rem;
  color: white;
}
.SocialMediaCard_container div button .icon {
  width: 1.875rem;
  height: 1.875rem;
}
.TableModal .ant-modal-header {
  border: none !important;
}
.table_pagination .ant-pagination-options {
  display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/CustomerSegmentsTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,wBAAwB;AAC1B","sourcesContent":[".checkBox_container {\n  display: flex;\n  justify-content: center;\n}\n.SocialMediaCard_container {\n  padding: 3.125rem;\n  background-color: #f1f1f1;\n  border-radius: 1.25rem;\n  height: 100%;\n  align-items: center;\n}\n.SocialMediaCard_container div {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n.SocialMediaCard_container div button {\n  border-radius: 0.625rem;\n  display: flex;\n  gap: 0.625rem;\n  align-items: center;\n  width: 13.125rem;\n  color: white;\n}\n.SocialMediaCard_container div button .icon {\n  width: 1.875rem;\n  height: 1.875rem;\n}\n.TableModal .ant-modal-header {\n  border: none !important;\n}\n.table_pagination .ant-pagination-options {\n  display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
